import { render, staticRenderFns } from "./ParentLearnerMarksheetHSC.vue?vue&type=template&id=cf1b53ca&scoped=true&"
import script from "./ParentLearnerMarksheetHSC.vue?vue&type=script&lang=js&"
export * from "./ParentLearnerMarksheetHSC.vue?vue&type=script&lang=js&"
import style0 from "./ParentLearnerMarksheetHSC.vue?vue&type=style&index=0&id=cf1b53ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1b53ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCol,VRow,VSimpleTable,VSnackbar})
